import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

export const MicrosoftIcon: React.FC<IconProps> = ({
  size = 24,
  color = Colors.role.textStrong,
  style,
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    overflow="visible"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M11.4 24H0V12.6H11.4V24Z" fill={color} />
    <Path d="M24 24H12.6V12.6H24V24Z" fill={color} />
    <Path d="M11.4 11.4H0V0H11.4V11.4Z" fill={color} />
    <Path d="M24 11.4H12.6V0H24V11.4Z" fill={color} />
  </Svg>
);

MicrosoftIcon.displayName = 'MicrosoftIcon';
